/* eslint-disable max-len */
import { IconProps } from 'models/icons';
import React from 'react';

const IsConnectingcon: React.FC<IconProps> = ({ color, ...props }) => (
  <svg width="19" height="12" viewBox="0 0 19 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5.75 0C6.16405 0.000197845 6.5 0.335909 6.5 0.75C6.5 1.16409 6.16405 1.4998 5.75 1.5C3.40279 1.5 1.5 3.40279 1.5 5.75C1.5 8.09721 3.40279 10 5.75 10C8.09704 9.9998 10 8.09709 10 5.75C10 5.33579 10.3358 5 10.75 5C11.164 5.0002 11.5 5.33591 11.5 5.75C11.5 8.92552 8.92547 11.4998 5.75 11.5C2.57436 11.5 0 8.92564 0 5.75C0 2.57436 2.57436 0 5.75 0ZM12.416 0C15.5917 0 18.166 2.57436 18.166 5.75C18.166 8.92564 15.5917 11.5 12.416 11.5C12.002 11.4998 11.666 11.1641 11.666 10.75C11.666 10.3359 12.002 10.0002 12.416 10C14.7632 10 16.666 8.09721 16.666 5.75C16.666 3.40279 14.7632 1.5 12.416 1.5C10.069 1.5002 8.16602 3.40291 8.16602 5.75C8.16602 6.16421 7.83023 6.5 7.41602 6.5C7.00197 6.4998 6.66602 6.16409 6.66602 5.75C6.66602 2.57448 9.24055 0.000197909 12.416 0Z"
      fill={color ?? props?.style?.color}
    />
  </svg>
);

export default IsConnectingcon;
